import { useWoopWorkloadSpec } from 'features/cluster/workload-optimization/_hooks/useWoopWorkloadSpec';
import { PreparedWorkload } from 'features/workload-optimization';

import { ManifestTabContent } from '../ManifestTabContent';

type ManifestContentProps = {
  workload: PreparedWorkload;
};

export const ManifestContent = ({
  workload: { id, clusterId, isCustom },
}: ManifestContentProps) => {
  const { data, isLoading, error, refetch } = useWoopWorkloadSpec({
    clusterId,
    workloadId: id,
    enabled: !isCustom,
  });

  return (
    <ManifestTabContent
      data={data}
      isLoading={isLoading}
      error={error}
      refetch={refetch}
      isCustom={isCustom}
      testId="manifest-content"
      emptyStateTitle="Manifest unavailable for custom workloads"
      loadingTitle="Fetching manifest"
    />
  );
};
